Vendd.Scripts.load(function () {

    $('.x-control.x-htmlarea-slider').each(function (i, wrapper) {

        if (!$(wrapper).data('init'))
            return;

        var defOptions = {
            slides: '> *',
            fx: 'scrollHorz',
            log: false,
            prev: $('.prev', $(wrapper)),
            next: $('.next', $(wrapper)),
            pager: $('.pager', $(wrapper)),
            pagerTemplate: '<span></span>'
        };

        var $options = $('*[data-input="options"]', $(wrapper));
        if ($options.length == 0)
            return;

        var opts = {};
        $.extend(true, opts, defOptions, JSON.parse($options.val()));

        if ($(wrapper).data('grouping')) {
            if ($(wrapper).children('ul').length > 1) {
                opts.slides = 'ul';
                $(wrapper).cycle(opts);               
            }
        } else {
            var $list = $('> ul', $(wrapper));
            if ($list.children().length > 1) {
                $list.cycle(opts);               
            }
        }

        $options.remove();
    });

});